import ReactMarkdown from 'react-markdown';

import { enhance } from './enhancers';

export const Markdown = enhance(ReactMarkdown);

export default Markdown;
